import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import React, { useContext, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { Container, Typography } from "@mui/material";
import { CardContent, CardActions, Button, Box, Card } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { locationContext } from "../../Context/CustomContext";
import { useLocationContext } from "../../Hooks/CustomHooks";
import { StyledCard } from "./homeStyles";
import { appInsights } from "../../ApplicationInsightsService";



const CustomCard = ({ title, path, description }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    appInsights.trackEvent({
      name: `handleClick method to  navigate to ${path} page`,
    });
    navigate(path);
  };
  return (
    <>
      <StyledCard variant="elevation" onClick={handleClick}>
        <CardContent>
          <Typography fontSize={25} mb={1} color="primary">
            {title}
          </Typography>
          <Typography>{description}</Typography>
        </CardContent>
      </StyledCard>
    </>
  );
};
const User = () => {
  const { instance, accounts } = useMsal();
  var currentUser = accounts[0].name;
  var Id= accounts[0].username
  useEffect(() => {appInsights.trackEvent({
    name: `User : ${Id} log in Successful`
  });});
  return (
    <>
      <Container>
        <Typography fontSize={30} ml={20}>
          Welcome {currentUser}
        </Typography>
        <br></br>
      </Container>
    </>
  );
};
const Menu = () => {
  return (
    <Container
      sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
    >
      <Box>
        <CustomCard
          path="/getallpipelines"
          title="List Pipeline"
          description="listing pipeline details used for file transfer"
        />
      </Box>
      <Box>
        <CustomCard
          path="/getalllookupdata"
          title="List LookUp"
          description="listing LookUp details used for file transfer"
        />
      </Box>
    </Container>
  );
};
const Home = () => {
  const location = useLocationContext();
  
  return (
    <div>
      <AuthenticatedTemplate>
        <Box>
          <User />
          <Menu />
        </Box>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Container sx={{ boxShadow: 4, marginTop: 10 }}>
          <Box py={8}>
            <Typography fontSize={70}>
              Welcome to File Transfer Admin...
            </Typography>
            <Typography fontSize={35}>please Sign in to Proceed</Typography>
          </Box>
        </Container>
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Home;
